import { HeatCellGroup, HeatTabConstant, ReadingCell } from './types';

// Перечень вкладок в отчете.
export const HeatTabConstants: HeatTabConstant[] = [
  { text: 'отчет', value: 'report' },
  { text: 'графики', value: 'charts' },
  { text: 'данные из ПУ', value: 'data' },
  { text: 'информация об отчете', value: 'info' },
];

// Перечень и порядок выводимых в отчете полей.
export const HeatCellPosition: HeatCellGroup[] = [
  { name: '', cells: ['datetime', 'time', 'NS'] },
  {
    name: 'Учет отопления (ТВ-1)',
    cells: ['M1', 'M2', 'dM_1', 'T1', 'T2', 'dT', 'P1', 'P2', 'Qo'],
  },
  {
    name: 'Учет ГВС (ТВ-2)',
    cells: ['M3', 'M4', 'dM_2', 'V3', 'V4', 'dV', 'Vp', 'T3', 'T4', 'Qg'],
  },
  { name: 'Контрольные данные', cells: ['Q_1', 'Q_2'] },
  { name: 'Общее теплопотребление', cells: ['Q'] },
];

// Перечень и порядок выводимых в показаниях полей.
export const ReadingsCellPosition: ReadingCell[] = [
  '_date',
  'M1',
  'M2',
  'M3',
  'M4',
  'V3',
  'V4',
  'Q',
  'time',
];
